export const debug = import.meta.env.DEV
